import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuthorized from "hooks/useAuthorized";
import { invalidateCampaignStatusPresetsTableQuery } from "hooks/useCampaignStatusPresetsTable";
import CampaignStatusPresetModal from "routes/campaign_status_presets/components/CampaignStatusPresetModal";
import DeleteCampaignStatusPresetModal from "routes/campaign_status_presets/components/DeleteCampaignStatusPresetModal";

export function CampaignStatusPresetsTableActions({ original }) {
  const canEdit = useAuthorized([
    ACL_RELATIONSHIPS.campaignStatusPreset.edit,
    ACL_RELATIONSHIPS.campaignStatuses.read,
  ]);
  const canDelete = useAuthorized([
    ACL_RELATIONSHIPS.campaignStatusPreset.delete,
  ]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Preset actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <CampaignStatusPresetModal
        preset={original}
        open={editOpen}
        onOpenChange={setEditOpen}
        fetchPresets={invalidateCampaignStatusPresetsTableQuery}
      />
      <DeleteCampaignStatusPresetModal
        preset={original}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        fetchPresets={invalidateCampaignStatusPresetsTableQuery}
      />
    </>
  );
}
